import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/joy/Alert';
import { AlertType } from '../../lib/interfaces';

export interface PopupAlertProps {
  open: boolean;
  message: string;
  type: AlertType;
  onClose?: () => void;
}

const PopupAlert = (props: PopupAlertProps) => {
  const { open, message, type, onClose } = props;
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => onClose?.()}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert sx={{ m: 4 }} color={type} variant="solid">
        {' '}
        {message}{' '}
      </Alert>
    </Snackbar>
  );
};

export default PopupAlert;
